import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import { fetchCoversByFolderThunk, selectCoversMetaState } from '@/redux/slices/coverSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { BaseFileEnum } from '@/typings/domain'
import { useFocusEffect } from 'expo-router'
import { useCallback } from 'react'
import CoverList from './CoverList'

type CoversByFolderProps = {
  folderToken: string
}

export default function CoversByFolder({ folderToken }: CoversByFolderProps) {
  const dispatch = useAppDispatch()
  const formCoversLoaded = useAppSelector(
    state => selectCoversMetaState(state, { folderToken }, BaseFileEnum.Form).loaded
  )
  const folderCoversLoaded = useAppSelector(
    state => selectCoversMetaState(state, { folderToken }, BaseFileEnum.FormFolder).loaded
  )

  const refetchCovers = useCallback(() => {
    dispatch(fetchCoversByFolderThunk({ folderToken, type: BaseFileEnum.FormFolder, reset: true }))
    dispatch(fetchCoversByFolderThunk({ folderToken, type: BaseFileEnum.Form, reset: true }))
  }, [dispatch, folderToken])

  useFocusEffect(refetchCovers)

  const handleLoadMore = useCallback(
    (type: BaseFileEnum) => {
      dispatch(fetchCoversByFolderThunk({ folderToken, type }))
    },
    [dispatch, folderToken]
  )

  if (!folderCoversLoaded && !formCoversLoaded) {
    return (
      <Center className="h-[20vh]">
        <Spinner />
      </Center>
    )
  }

  return <CoverList folderToken={folderToken} includeFolder onLoadMore={handleLoadMore} onRefresh={refetchCovers} />
}
